import React, { useState, useEffect } from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Image
} from 'react-bootstrap';

import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';


function AddProduct() {

  const { user, authLoaded } = useAuth();
  const navigate = useNavigate();


  // ================================
  // PRODUCT FORM STATE
  // ================================

  const [form, setForm] = useState({

    name: '',
    brand: '',
    category: '',
    description: '',

    price: '0',
    countInStock: '0',

    images: [],


    // NEW PRODUCT FEATURES
  features: {

    featured: false,

    newArrival: false,

    bestSeller: false,

    onSale: false,

    freeShipping: false

  }

  });


  const [preview, setPreview] = useState([]);

  const [loading, setLoading] = useState(false);



  // ================================
  // ADMIN CHECK
  // ================================

  useEffect(() => {

    if (!authLoaded) return;


    if (!user) {

      navigate('/login');

      return;

    }


    if (!user.isAdmin) {

      navigate('/');

    }


  }, [authLoaded, user, navigate]);





  // ================================
  // HANDLE TEXT INPUT
  // ================================

  const handleChange = (e) => {

    setForm({

      ...form,

      [e.target.name]: e.target.value

    });

  };





  // ================================
  // HANDLE FEATURE CHECKBOX
  // ================================


  /*
  const handleFeatureChange = (e) => {


    const { name, checked } = e.target;


    setForm({

      ...form,


      features: {

        ...form.features,

        [name]: checked

      }


    });


  };

  

  const handleFeatureChange = (e) => {

  const { name, checked } = e.target;

  const updatedFeatures = {
    ...form.features
  };

  // Active Product is independent
  if (name === "active") {
    updatedFeatures.active = checked;
  } else {

    // Turn OFF all promotional features first
    updatedFeatures.featured = false;
    updatedFeatures.bestSeller = false;
    updatedFeatures.newArrival = false;

    // Turn ON only the selected one
    updatedFeatures[name] = checked;
  }

  setForm({
    ...form,
    features: updatedFeatures
  });

};

*/

const handleFeatureChange = (e) => {

  const { name, checked } = e.target;

  const updatedFeatures = {
    ...form.features
  };

  // Only ONE promotional feature is allowed
  if (
    name === "featured" ||
    name === "bestSeller" ||
    name === "newArrival" ||
    name === "onSale"
  ) {

    updatedFeatures.featured = false;
    updatedFeatures.bestSeller = false;
    updatedFeatures.newArrival = false;
    updatedFeatures.onSale = false;

    updatedFeatures[name] = checked;

  } else {

    // Free Shipping
    updatedFeatures[name] = checked;

  }

  setForm({
    ...form,
    features: updatedFeatures
  });

};




  // ================================
  // ADD IMAGE
  // ================================

  const handleAddImage = (e) => {


    const file = e.target.files[0];


    if (!file) return;



    if (form.images.length >= 3) {

      alert('Maximum 3 images allowed');

      return;

    }



    setForm({

      ...form,

      images: [

        ...form.images,

        file

      ]

    });



    setPreview([

      ...preview,

      URL.createObjectURL(file)

    ]);



    e.target.value = null;


  };





  // ================================
  // REMOVE IMAGE
  // ================================

  const handleRemoveImage = (index) => {


    setForm({

      ...form,

      images: form.images.filter(

        (_, i) => i !== index

      )

    });



    setPreview(

      preview.filter(

        (_, i) => i !== index

      )

    );


  };


  // ================================
// SUBMIT PRODUCT
// ================================

const handleSubmit = async (e) => {

  e.preventDefault();


  if (form.images.length === 0) {

    alert('Upload at least one image');

    return;

  }

  const selectedPromotion = [

    form.features.featured,
    form.features.bestSeller,
    form.features.newArrival,
    form.features.onSale

    ].filter(Boolean).length;

    if (selectedPromotion > 1) {

        alert(
            "Please select only ONE promotional category."
        );

        return;

  }



  const formData = new FormData();


  // Basic fields

  formData.append('name', form.name);

  formData.append('brand', form.brand);

  formData.append('category', form.category);

  formData.append('description', form.description);


  formData.append(
    'price',
    parseFloat(form.price)
  );


  formData.append(
    'countInStock',
    parseInt(form.countInStock)
  );



  // NEW FEATURES
  formData.append(

    'features',

    JSON.stringify(form.features)

  );



  // Images

  form.images.forEach((img) => {

    formData.append(

      'photos',

      img

    );

  });



  setLoading(true);



  try {


    await axios.post(

      'https://apimyshop.myidealtd.co.uk/api/products/add-product',

      formData,

      {

        headers: {

          'Content-Type': 'multipart/form-data'

        },

        withCredentials: true

      }

    );



    alert('Product added successfully!');


    navigate('/');



  } catch (err) {


    console.error(err);


    alert(

      err.response?.data?.message ||

      'Upload failed'

    );


  } finally {


    setLoading(false);


  }


};





return (

<Container className="my-5">

<Row className="justify-content-center">

<Col xs={12} md={10} lg={8}>


<Card className="shadow-sm p-4">


<h3 className="text-center mb-4">

Add New Product

</h3>



<Form onSubmit={handleSubmit}>


{/* ============================
NAME + BRAND
============================= */}


<Row className="g-3">


<Col md={6}>

<Form.Group>


<Form.Label>

Product Name

</Form.Label>


<Form.Control

type="text"

name="name"

placeholder="Product Name"

value={form.name}

onChange={handleChange}

required

/>


</Form.Group>


</Col>




<Col md={6}>


<Form.Group>


<Form.Label>

Brand

</Form.Label>


<Form.Control

type="text"

name="brand"

placeholder="Brand Name"

value={form.brand}

onChange={handleChange}

required

/>


</Form.Group>


</Col>


</Row>





{/* ============================
CATEGORY + PRICE
============================= */}


<Row className="g-3 mt-2">


<Col md={6}>


<Form.Group>


<Form.Label>

Category

</Form.Label>


<Form.Control

type="text"

name="category"

placeholder="Category"

value={form.category}

onChange={handleChange}

required

/>


</Form.Group>


</Col>





<Col md={6}>


<Form.Group>


<Form.Label>

Price (£)

</Form.Label>


<Form.Control

type="number"

name="price"

min="0"

step="0.01"

value={form.price}

onChange={handleChange}

required

/>


</Form.Group>


</Col>


</Row>





{/* ============================
STOCK + FEATURES
============================= */}


<Row className="g-3 mt-2">


<Col md={6}>


<Form.Group>


<Form.Label>

Stock Quantity

</Form.Label>


<Form.Control

type="number"

name="countInStock"

min="0"

value={form.countInStock}

onChange={handleChange}

required

/>


</Form.Group>


</Col>





<Col md={6}>


<Form.Label>

Product Features

</Form.Label>


<div className="border rounded p-3">




<Form.Check

type="checkbox"

label="Featured Product"

name="featured"

checked={form.features.featured}

onChange={handleFeatureChange}

/>



<Form.Check

type="checkbox"

label="New Arrival"

name="newArrival"

checked={form.features.newArrival}

onChange={handleFeatureChange}

/>



<Form.Check

type="checkbox"

label="Best Seller"

name="bestSeller"

checked={form.features.bestSeller}

onChange={handleFeatureChange}

/>

<Form.Check

type="checkbox"

label="On Sale"

name="onSale"

checked={form.features.onSale}

onChange={handleFeatureChange}

/>



<Form.Check

type="checkbox"

label="Free Shipping"

name="freeShipping"

checked={form.features.freeShipping}

onChange={handleFeatureChange}

/>









</div>


</Col>


</Row>





{/* ============================
IMAGES
============================= */}


<Row className="mt-3">


<Col>


<Form.Label>

Product Images (Max 3)

</Form.Label>



<div className="d-flex flex-wrap gap-3">


{preview.map((src, idx) => (


<div

key={idx}

style={{

position:'relative',

width:100,

height:100

}}

>


<Image

src={src}

rounded

style={{

width:'100%',

height:'100%',

objectFit:'cover',

borderRadius:8

}}

/>



<Button

variant="danger"

size="sm"

onClick={() => handleRemoveImage(idx)}

style={{

position:'absolute',

top:-8,

right:-8,

borderRadius:'50%',

width:25,

height:25,

padding:0

}}

>

×

</Button>


</div>


))}





{form.images.length < 3 && (


<Button

as="label"

htmlFor="imageUpload"

variant="outline-secondary"

style={{

width:100,

height:100,

fontSize:30,

display:'flex',

alignItems:'center',

justifyContent:'center',

cursor:'pointer'

}}

>

+

</Button>


)}



<input

id="imageUpload"

type="file"

accept="image/*"

style={{display:'none'}}

onChange={handleAddImage}

/>



</div>


</Col>


</Row>





{/* ============================
DESCRIPTION
============================= */}


<Form.Group className="mt-4">


<Form.Label>

Description

</Form.Label>



<Form.Control

as="textarea"

rows={4}

name="description"

placeholder="Product description..."

value={form.description}

onChange={handleChange}

required

/>


</Form.Group>





{/* ============================
SUBMIT BUTTON
============================= */}


<div className="d-grid mt-4">


<Button

type="submit"

variant="primary"

disabled={loading}

>


{

loading

?

'Uploading Product...'

:

'Add Product'

}


</Button>


</div>



</Form>


</Card>


</Col>


</Row>


</Container>


);


}


export default AddProduct;